(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-directory-editorial"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.collectionDirectoryLoadMoreReady) return;
    window.collectionDirectoryLoadMoreReady = true;

    const rowsFor = (root) => Array.from(root.querySelectorAll('.collection-directory__inner > .collection-directory__row'));
    const pagers = new WeakMap();
    const revealObservers = new WeakMap();
    const revealRows = (root) => {
      const rows = rowsFor(root);
      if (root.dataset.scrollAnimation !== 'true' || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        rows.forEach((row) => row.classList.remove('is-directory-pending'));
        revealObservers.get(root)?.disconnect();
        revealObservers.delete(root);
        return;
      }
      let observer = revealObservers.get(root);
      if (!observer) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.remove('is-directory-pending');
            entry.target.classList.add('is-directory-revealed');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.05 });
        revealObservers.set(root, observer);
      }
      rows.forEach((row) => {
        if (row.hidden || row.classList.contains('is-directory-revealed')) return;
        if (row.getBoundingClientRect().top <= window.innerHeight) {
          row.classList.remove('is-directory-pending');
          row.classList.add('is-directory-revealed');
          observer.unobserve(row);
        } else {
          row.classList.add('is-directory-pending');
          observer.observe(row);
        }
      });
    };
    const pageFromUrl = (key, total) => {
      const value = new URL(window.location.href).searchParams.get(key);
      const page = /^\d+$/.test(value || '') ? Number(value) : 1;
      return page >= 1 && page <= total ? page : 1;
    };
    const initPagination = (root) => {
      const nav = root.querySelector('.collection-directory__pagination');
      if (!nav) return;
      const rows = rowsFor(root);
      const size = Number.parseInt(root.dataset.itemsPerPage, 10) || 12;
      const total = Math.max(1, Math.ceil(rows.length / size));
      const key = document.querySelector('[data-collection-directory]') === root ? 'collection_page' : `collection_page_${root.id}`;
      const list = nav.querySelector('ul');
      const prev = nav.querySelector('[data-directory-prev]');
      const next = nav.querySelector('[data-directory-next]');
      const show = (page, userAction = false) => {
        page = Math.max(1, Math.min(page, total));
        const fragment = document.createDocumentFragment();
        let last = 0;
        const start = Math.max(2, Math.min(page - 1, total - 2));
        const end = Math.min(total - 1, Math.max(page + 1, 3));
        for (let number = 1; number <= total; number += 1) {
          if (total > 7 && number !== 1 && number !== total && (number < start || number > end)) continue;
          if (last && number - last > 1) {
            const gap = document.createElement('li');
            gap.dataset.directoryPageItem = '';
            gap.innerHTML = '<span class="pagination__ellipsis">…</span>';
            fragment.append(gap);
          }
          const item = document.createElement('li');
          item.dataset.directoryPageItem = '';
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = String(number);
          button.dataset.directoryPage = String(number);
          button.className = number === page ? 'pagination__page-current' : 'pagination__page-link';
          button.setAttribute('aria-controls', root.querySelector('.collection-directory__inner').id);
          if (number === page) button.setAttribute('aria-current', 'page');
          item.append(button);
          fragment.append(item);
          last = number;
        }
        list.querySelectorAll('[data-directory-page-item]').forEach((item) => item.remove());
        list.insertBefore(fragment, next.parentElement);
        prev.disabled = page === 1;
        next.disabled = page === total;
        nav.hidden = total <= 1;
        root.classList.add('is-enhanced');
        rows.forEach((row, index) => { row.hidden = index < (page - 1) * size || index >= page * size; });
        root.querySelector('[data-directory-initial-page]')?.remove();
        root.dataset.directoryPage = String(page);
        revealRows(root);
        if (userAction) {
          try {
            const url = new URL(window.location.href);
            url.searchParams.set(key, String(page));
            window.history.replaceState(window.history.state, '', url);
          } catch (error) {}
          nav.querySelector('[aria-current="page"]')?.focus({ preventScroll: true });
          window.scrollTo({ top: Math.max(0, root.getBoundingClientRect().top + window.scrollY - 32), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }
      };
      const onClick = (event) => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const current = Number(root.dataset.directoryPage);
        const page = button === prev ? current - 1 : button === next ? current + 1 : Number(button.dataset.directoryPage);
        if (page) show(page, true);
      };
      try {
        nav.addEventListener('click', onClick);
        show(pageFromUrl(key, total));
        pagers.set(root, { show, size, key, total });
      } catch (error) {
        nav.removeEventListener('click', onClick);
        root.querySelector('[data-directory-initial-page]')?.remove();
        rows.forEach((row) => { row.hidden = false; });
        nav.hidden = true;
        root.classList.remove('is-enhanced');
        delete root.dataset.directoryEnhanced;
      }
    };

    const update = (root, visibleCount) => {
      const rows = rowsFor(root);
      const buttonWrap = root.querySelector('.collection-directory__load-more-wrap');
      const button = root.querySelector('.collection-directory__load-more');
      const count = Math.min(visibleCount, rows.length);

      rows.forEach((row, index) => {
        row.hidden = index >= count;
      });
      revealRows(root);

      if (button && buttonWrap) {
        button.dataset.visibleCount = String(count);
        const complete = count >= rows.length;
        button.disabled = complete;
        buttonWrap.hidden = complete;
      }
    };

    const init = (root) => {
      if (!root || root.dataset.directoryEnhanced === 'true') return;
      root.dataset.directoryEnhanced = 'true';

      if (root.dataset.paginationMode === 'pagination') {
        initPagination(root);
        return;
      }

      if (root.dataset.paginationMode !== 'load_more') return;

      const button = root.querySelector('.collection-directory__load-more');
      const buttonWrap = root.querySelector('.collection-directory__load-more-wrap');
      if (!button || !buttonWrap) return;

      const revealMore = () => {
        const current = Number.parseInt(button.dataset.visibleCount, 10) || 0;
        const increment = Number.parseInt(root.dataset.itemsPerLoad, 10) || 6;
        update(root, current + increment);
      };

      try {
        button.addEventListener('click', revealMore);
        update(root, Number.parseInt(root.dataset.initialItems, 10) || 6);
        root.classList.add('is-enhanced');
      } catch (error) {
        button.removeEventListener('click', revealMore);
        rowsFor(root).forEach((row) => { row.hidden = false; });
        buttonWrap.hidden = true;
        root.classList.remove('is-enhanced');
        delete root.dataset.directoryEnhanced;
      }
    };

    const initWithin = (scope) => {
      const initRoot = (root) => {
        init(root);
        revealRows(root);
      };
      if (scope.matches && scope.matches('[data-collection-directory]')) initRoot(scope);
      scope.querySelectorAll?.('[data-collection-directory]').forEach(initRoot);
    };

    initWithin(document);
    document.addEventListener('DOMContentLoaded', () => initWithin(document));
    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.('[data-collection-directory]').forEach((root) => {
        revealObservers.get(root)?.disconnect();
        revealObservers.delete(root);
        pagers.delete(root);
      });
    });
    window.addEventListener('popstate', () => {
      document.querySelectorAll('[data-collection-directory]').forEach((root) => {
        const pager = pagers.get(root);
        if (pager) pager.show(pageFromUrl(pager.key, pager.total));
      });
    });
    document.addEventListener('shopify:block:select', (event) => {
      const row = event.target.closest?.('.collection-directory__row');
      const root = row?.closest('[data-collection-directory]');
      if (!row || !root || !root.classList.contains('is-enhanced')) return;

      const rows = rowsFor(root);
      const pager = pagers.get(root);
      if (pager) {
        pager.show(Math.floor(rows.indexOf(row) / pager.size) + 1);
        return;
      }
      const button = root.querySelector('.collection-directory__load-more');
      const current = Number.parseInt(button?.dataset.visibleCount, 10) || 0;
      update(root, Math.max(current, rows.indexOf(row) + 1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if (this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-projects-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('home-projects-showcase')) {
    customElements.define('home-projects-showcase', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        if (this.dataset.initialized === 'true') return;
        this.cards = Array.from(this.querySelectorAll('[data-project-card]'));
        this.track = this.querySelector('[data-project-track]');
        if (!this.track) return;
        this.dataset.initialized = 'true';
        this.controls = this.querySelector('[data-project-controls]');
        this.previousButton = this.querySelector('[data-project-previous]');
        this.nextButton = this.querySelector('[data-project-next]');
        this.status = this.querySelector('[data-project-status]');
        this.switchingEnabled = this.dataset.switchingEnabled === 'true';

        this.previousButton?.addEventListener('click', () => this.move(-1));
        this.nextButton?.addEventListener('click', () => this.move(1));
        this.addEventListener('click', (event) => this.onGalleryClick(event));
        this.onTrackScroll = () => requestAnimationFrame(() => this.updateCarouselControls());
        this.track.addEventListener('scroll', this.onTrackScroll, { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateCarouselControls());
        this.resizeObserver.observe(this.track);
        this.updateCarouselControls();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.track?.removeEventListener('scroll', this.onTrackScroll);
      }

      getScrollAmount() {
        const card = this.cards[0];
        if (!card) return this.track.clientWidth;
        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || 0);
        return card.getBoundingClientRect().width + gap;
      }

      move(direction) {
        if (!this.switchingEnabled || !this.track) return;
        const amount = this.getScrollAmount();
        const targetIndex = Math.max(0, Math.min(this.cards.length - 1, Math.round((this.track.scrollLeft + (amount * direction)) / amount)));
        this.track.scrollBy({
          left: amount * direction,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
        if (this.status) this.status.textContent = this.cards[targetIndex]?.dataset.projectTitle || '';
      }

      updateCarouselControls() {
        if (!this.controls || !this.track) return;
        const canScroll = this.switchingEnabled && this.track.scrollWidth > this.track.clientWidth + 1;
        this.controls.hidden = !canScroll;
        if (!canScroll) return;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 1;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
      }

      onGalleryClick(event) {
        const thumbnail = event.target.closest('[data-project-thumbnail]');
        if (!thumbnail || !this.contains(thumbnail)) return;
        const gallery = thumbnail.closest('[data-project-gallery]');
        const mainLink = gallery?.querySelector('[data-project-main]');
        const mainItem = mainLink?.querySelector('[data-project-gallery-item]');
        const thumbnailItem = thumbnail.querySelector('[data-project-gallery-item]');
        const mainImage = mainItem?.querySelector('.home-projects-showcase__image');
        const thumbnailImage = thumbnailItem?.querySelector('.home-projects-showcase__image');
        if (!gallery || !mainLink || !mainItem || !thumbnailItem || !mainImage || !thumbnailImage) return;

        const completeSwap = () => {
          const activeImageIndex = thumbnailItem.dataset.imageIndex;
          const mainSizes = mainImage.getAttribute('sizes');
          const thumbnailSizes = thumbnailImage.getAttribute('sizes');
          mainImage.setAttribute('sizes', thumbnailSizes || '124px');
          thumbnailImage.setAttribute('sizes', mainSizes || '100vw');
          mainLink.insertBefore(thumbnailItem, mainLink.firstChild);
          thumbnail.appendChild(mainItem);
          const counter = gallery.querySelector('[data-project-counter]');
          if (counter) counter.textContent = `${activeImageIndex} / ${gallery.dataset.projectImageCount}`;
          thumbnail.setAttribute(
            'aria-label',
            `View image ${mainItem.dataset.imageIndex} for ${gallery.dataset.projectTitle}`
          );
          gallery.querySelectorAll('[data-project-thumbnail]').forEach((button) => {
            button.setAttribute('aria-pressed', String(button === thumbnail));
          });
          requestAnimationFrame(() => {
            mainLink.classList.remove('is-changing');
            thumbnail.classList.remove('is-changing');
          });
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          completeSwap();
          return;
        }

        mainLink.classList.add('is-changing');
        thumbnail.classList.add('is-changing');
        window.setTimeout(completeSwap, 85);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(err => console.error('Product recommendations error:', err));
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px'
    });

    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-main-product"]) return;
  try {
    
  const productRecommendationsSection = document.querySelector('.product-recommendations');

  if (productRecommendationsSection) {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      observer.unobserve(productRecommendationsSection);

      const url = productRecommendationsSection.dataset.url;
      if (!url) return;

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;

          const recommendations = html.querySelector('.product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length > 0) {
            productRecommendationsSection.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(err => console.error('Product recommendations error:', err));
    };

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: '0px 0px 200px 0px'
    });

    observer.observe(productRecommendationsSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["projects-overview-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.munestProjectsOverviewFilters) {
    window.munestProjectsOverviewFilters = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-project-filter]');
      if (!button) return;
      const section = button.closest('[data-projects-section]');
      if (!section) return;
      const selectedFilter = button.dataset.projectFilter;
      section.querySelectorAll('[data-project-filter]').forEach((filterButton) => {
        const isActive = filterButton === button;
        filterButton.classList.toggle('is-active', isActive);
        filterButton.setAttribute('aria-pressed', String(isActive));
      });
      let visibleCount = 0;
      section.querySelectorAll('[data-project-card]').forEach((card) => {
        const isVisible = selectedFilter === 'all' || card.dataset.projectType === selectedFilter;
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });
      const emptyMessage = section.querySelector('[data-projects-empty]');
      if (emptyMessage) emptyMessage.hidden = visibleCount > 0;
    });
  }

  if (!window.munestProjectsOverviewGalleries) {
    window.munestProjectsOverviewGalleries = true;
    document.addEventListener('click', (event) => {
      const thumbnail = event.target.closest('[data-project-thumbnail]');
      if (!thumbnail) return;
      const gallery = thumbnail.closest('[data-project-gallery]');
      if (!gallery) return;
      const mainLink = gallery.querySelector('[data-project-main]');
      const mainItem = mainLink?.querySelector('[data-project-gallery-item]');
      const thumbnailItem = thumbnail.querySelector('[data-project-gallery-item]');
      const mainImage = mainItem?.querySelector('.projects-overview-grid__image');
      const thumbnailImage = thumbnailItem?.querySelector('.projects-overview-grid__image');
      if (!mainLink || !mainItem || !thumbnailItem || !mainImage || !thumbnailImage) return;

      const completeSwap = () => {
        const mainSizes = mainImage.getAttribute('sizes');
        const thumbnailSizes = thumbnailImage.getAttribute('sizes');
        mainImage.setAttribute('sizes', thumbnailSizes || '50vw');
        thumbnailImage.setAttribute('sizes', mainSizes || '100vw');
        mainLink.appendChild(thumbnailItem);
        thumbnail.appendChild(mainItem);
        const counter = gallery.querySelector('[data-project-counter]');
        if (counter) {
          counter.textContent = `${thumbnailItem.dataset.imageIndex} / ${gallery.dataset.projectImageCount}`;
        }
        thumbnail.setAttribute(
          'aria-label',
          `View image ${mainItem.dataset.imageIndex} for ${gallery.dataset.projectTitle}`
        );
        gallery.querySelectorAll('[data-project-thumbnail]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button === thumbnail));
        });
        requestAnimationFrame(() => {
          mainLink.classList.remove('is-changing');
          thumbnail.classList.remove('is-changing');
        });
      };

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        completeSwap();
        return;
      }

      mainLink.classList.add('is-changing');
      thumbnail.classList.add('is-changing');
      window.setTimeout(completeSwap, 90);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
